export default "__VITE_ASSET__f66e9e9c__"